import React from 'react';
import OfferContent from '../OfferContent/OfferContent';

import './FeaturedOffer502x272.scss';

function FeaturedOffer502x272({ dataItem, shouldUseCarousel }) {
  const {
    assets, offerTitle, clickUrl, merchant, id,
  } = dataItem;

  return (
    <div
      className="mn_featuredOffer502x272"
      data-test="featured-offer-502x272"
      role={shouldUseCarousel ? '' : 'listitem'}
      data-merchant-name={merchant.name}
      data-deal-id={id}
      data-rollover-copy={assets.rolloverCopy}
    >
      <div className="mn_featuredOffer">
        <a href={clickUrl} title={`Opens a new window at ${merchant.name}`} target="_blank">
          <div className="mn_featuredOfferContentWrap">
            <figure className="mn_featureOfferImageWrap">
              <img src={assets._502x272} alt={offerTitle} />
            </figure>
            <OfferContent dataItem={dataItem} />
          </div>
        </a>
      </div>
    </div>
  );
}

export default FeaturedOffer502x272;
